import type { SlotKey } from '#packages/apilib';
import type { AiHtmlSectionUIApi } from './types';

export const AiHtmlSectionUIApiKey: SlotKey<AiHtmlSectionUIApi> = {
  name: 'AiHtmlSectionUIApi',
  public: false,
};
